import {Button, notification} from "antd";
import React from "react";

export const isIos = () => {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iphone|ipad|ipod/.test(userAgent);
};


export function convertRialToToman(x) {
    if(x){
        return x/10
    }else {
        return "0"
    }
}

export function convertTomanToRial(x) {
    if(x){
        return x*10
    }else {
        return "0"
    }
}


export function numberWithCommas(x) {
    // convert To toman
    // x= (x/10).toFixed(0)
    //add commas
    if(x){
        x= Math.round(x)
        return x?x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","):0;
    }else {
        return "0"
    }
}

export const isInStandaloneMode = () =>
    window.matchMedia('(display-mode: standalone)').matches;

// 'standalone' in window.navigator && window.navigator.standalone;

// isInWebAppiOS = (window.navigator.standalone == true);

export const isInWebAppChrome = () =>
    window.matchMedia('(display-mode: standalone)').matches;

export const ConvertTMonthName = (month) =>{
    let name= "";
    switch (month) {
        case '01':
            name =  "فروردین";
            break;
        case '02':
            name =  "اردیبهشت";
            break;
        case '03':
            name =  "خرداد";
            break;
        case '04':
            name =  "تیر";
            break;
        case '05':
            name =  "مرداد";
            break;
        case '06':
            name =  "شهریور";
            break;
        case '07':
            name =  "مهر";
            break;
        case '08':
            name =  "آبان";
            break;
        case '09':
            name =  "آذر";
            break;
        case '10':
            name =  "دی";
            break;
        case '11':
            name =  "بهمن";
            break;
        case '12':
            name =  "اسفند";
            break;
        default:
            name =  "---";
    }

    return name;
}


export const
    fixNumbers = function (str)
    {
        str = str.replace(/\s+/g, '');
        let persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
        let arabicNumbers  = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
        if(typeof str === 'string')
        {
            for(let i=0; i<10; i++)
            {
                str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
            }
        }
        return str;
    };

export const  detectEnglishLang = (text)=>{
    return (/^[a-zA-Z]+$/.test(text)) //if the English language
}



export const openNotificationWithIcon = (type,product,history,merchantId) => {
    const key = `open${Date.now()}`;
    const btn = (
        <Button type="primary" size="small" onClick={() => {
            notification.close(key)
            history.push(`/dr-shop/basket/${merchantId}`)
        }}>
            رفتن به سبد
        </Button>
    );

    notification.config({
        duration: 3,
    });

    notification[type]({
        message: ` ${ product.name } به سبد شما اضافه شد`,
        btn,
        key,
        style: {
            zIndex:2003
        },
    });
}

export const  getMallColor = ()=>{

    let theme = localStorage.getItem("theme")
    if(theme){
        let t = JSON.parse(theme)
        if(t.primary)
        return {primary:t.primary,secondary:t.secondary}
        else
        return {primary:"#31ccef",secondary:"#31ccef"}
    }
    else{
        return {primary:"#31ccef",secondary:"#31ccef"}
    }

}

export const convertVariantTypeNameWithVal  = (name,val)=>{
    switch(name){
        case "value - مقدار":
            return `مقدار${val}`
            break;
        case "packs - تعداد در بسته":
            return `${val} تایی`
            break;
        case "color - رنگ":
            return `رنگ ${val}`
            break;
        case "taste - طعم":
            return `طعم ${val}`
            break;
        case "size - اندازه":
            return `اندازه ${val}`
            break;
        case "smell - رایحه":
            return `رایحه ${val}`
            break;

        default:
            return ""
    }
}


export const convertVariantTypeName  = (name)=>{
    switch(name){
        case "value - مقدار":
            return "مقدار"
            break;
        case "packs - تعداد در بسته":
            return "تعداد"
            break;
        case "color - رنگ":
            return "رنگ"
            break;
        case "taste - طعم":
            return "طعم"
            break;
        case "size - اندازه":
            return "اندازه"
            break;
        case "smell - رایحه":
            return "رایحه"
            break;

        default:
            return ""
    }
}



export function H1Sec({data}){
    return(
        <h1 className="h1-sec">{data.props.children}</h1>
    )
}


export  function H2Sec({data}){
    return(
        <h2 className="h2-sec">{data.props.children}</h2>
    )
}

export  function PSec({data}){
    return(
        <p className="h2-sec">{data.props.children}</p>
    )
}

export  function OlSec({data}){
    return(
        <ol >
            {data.props.children.map(c=>{
                return(
                    <div className="ul-row">
                        <span>{c.props.children.key}</span>
                        <li>{c.props.children}</li>
                    </div>

                )
            })}
        </ol>
    )
}

export  function UlSec({data}){
    return(
        <ul>
            {data.props.children.map(c=>{
                return(
                    <div className="ul-row">
                        <span>{c.props.children.key}</span>
                        <li>{c.props.children}</li>
                    </div>

                )
            })}
        </ul>
    )
}
